module.exports = __webpack_public_path__ + "img/puzzle_9.2b93d2eb.png";